export const ACTIVITY_CONTENT = {
  activity: 'Activity',
  activities: 'Activities',
  activityLabels: {
    title: 'Title of the activity',
  },
};
